import {LocationStrategy} from "@angular/common";
import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {AppService} from "@api";
import {DatePickerV2Component} from "@componentes/DatePickerV2/DatePickerV2.component";
import {HeaderEnum, RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {AlertaEnum, DialogoEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {PeriodoEvaluacion} from "@modelo/proceso/periodoevaluacion.model";
import {SistemaService} from "@servicios/Sistema.Service";
import {DxDataGridComponent} from "devextreme-angular";


@Component({
    selector: 'periodoevaluacionForm',
    templateUrl: './periodoevaluacionForm.component.html',
    styleUrls: ['./periodoevaluacion.component.scss']
})


export class PeriodoEvaluacionFormComponent implements AfterViewInit {
    consulta!: boolean;
    entidad: PeriodoEvaluacion;
    @Input() accion!: {accionid: number, accion: string};
    @Input() id!: number;
    @Input() limpiarcampos!: number;
    @Output() output = new EventEmitter();
    cambio: boolean = false;
    public errorActivo!: boolean;
    ver: boolean;

    configuracionDatePicker: any;
    configuracionDatePicker2: any;
    configuracionDatePicker3: any;

    validationStatus: any[];
    SelCiclo: any[];
    SelDataPeriodoporTipo: any[];
    dataTipoEvaluacion: any[]
    listtipoevaluacioneliminar: any[];

    fechainicioperiodo: Date;
    fechainicioacuerdoparafin: Date;
    fechainicioacuerdo: Date;
    fechafinacuerdos: Date;
    maxDate: Date = new Date();
    minDate: Date = new Date();

    @ViewChild(DxDataGridComponent, {static: false}) grid!: DxDataGridComponent;

    @ViewChild("fechainicioperiodo", {static: false}) datepiker!: DatePickerV2Component;
    @ViewChild("fechainicioacuerdo", {static: false}) datepiker2!: DatePickerV2Component;
    @ViewChild("fechafinacuerdo", {static: false}) datepiker3!: DatePickerV2Component;



    constructor(private appService: AppService, private location: LocationStrategy, public sistemaService: SistemaService, private mensajeService: MensajeService) {
        this.entidad = new PeriodoEvaluacion();

        this.SelCiclo = [];
        this.validationStatus = []
        this.SelDataPeriodoporTipo = [];
        this.dataTipoEvaluacion = [];
        this.listtipoevaluacioneliminar = [];

        this.fechafinacuerdos = new Date();
        this.fechainicioacuerdo = new Date();
        this.fechainicioperiodo = new Date();
        this.fechainicioacuerdoparafin = new Date();
        this.ver = false;

    }

    ngAfterViewInit() {
        if (this.accion.accionid == 2) {
            this.ver = true;
        }
        this.SetPeriodoporTipo(this.id).then((res:any)=>{
            if(res){
                this.SetPeriodoEvaluacion()
                this.SetCiclo()
            }
        });
    }

    SetPeriodoEvaluacion() {
        this.appService.Post("planeacion/periodoevaluacion/buscar", {"periodoevaluacionid": this.id}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                if(res.data.length > 0){
                    this.entidad = new PeriodoEvaluacion(res.data[0]);
                    if(this.limpiarcampos == 0){
                        this.entidad.fechainicioperiodo = this.formatDate(res.data[0].fechainicioperiodo);
                        this.entidad.fechainicioacuerdos = this.formatDate(res.data[0].fechainicioacuerdos);
                        this.entidad.fechafinacuerdos = this.formatDate(res.data[0].fechafinacuerdos);
                    }else{
                        this.entidad.fechainicioperiodo = "";
                        this.entidad.fechainicioacuerdos = "";
                        this.entidad.fechafinacuerdos = "";
                        this.LimpiarFechasTabla();
                    }
                }
                this.ValidarFecha();
            }
        })
    }

    SetPeriodoporTipo(id: number) {
        return new Promise((resolve : any) =>{
        this.appService.Post("planeacion/periodoevaluacion/periodoevaluacionportipoevaluacion", {"periodoevaluacionid": id}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                res.data.forEach((x: any, i: number) => {
                    x.preguntaloconoces = x.preguntaloconoces ? true : false;
                })
                this.SelDataPeriodoporTipo = res.data;
                return resolve(true);
            }else{
                return resolve(false);
            }
        })
    });
    }

    onContentReady(e: any) {
        if (!e.component.isNotFirstLoad && this.SelDataPeriodoporTipo.length > 0 && this.SelDataPeriodoporTipo.length == this.grid.instance.getVisibleRows().length) {
            e.component.isNotFirstLoad = true;
            let selected: any[] = [];
            this.SelDataPeriodoporTipo.forEach((x: any, i: number) => {
                x.periodoevaluacionportipoevaluacionid ? selected.push(i) : null;
            })
            this.grid.instance.selectRowsByIndexes(selected);
        }

    }

    SetCiclo() {
        this.appService.Get("catalogo/ciclo").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelCiclo = res.data;
            }
        });
    }

    //Salir del formulario
    Salir() {
        if(this.limpiarcampos == 1){
            this.Eliminar(this.entidad);
        }else{
            this.output.next(this.cambio);
        }
    }

    Validar(): any {
        this.errorActivo = true;
        if (!this.entidad.cicloid) {
            return "Tienes que seleccionar un ciclo"
        }
        if (!this.entidad.descripcion) {
            return "Tienes que asignarle una descripción"
        }
        if (!this.entidad.fechainicioperiodo) {
            return "Tienes que seleccionar una fecha para el inicio del periodo"
        }
        if (!this.entidad.fechainicioacuerdos) {
            return "Tienes que seleccionar una fecha para el inicio de los acuerdos"
        }
        if (!this.entidad.fechafinacuerdos) {
            return "Tienes que seleccionar una fecha para el fin de los acuerdos"
        }
        let fechaevaluacion = this.grid.instance.getSelectedRowsData().find(row => !row.fechainicioevaluacion)
        if (fechaevaluacion) {
            return "Se tiene que asignar una fecha para el tipo de evaluación: "+ fechaevaluacion.nombre +": "+ fechaevaluacion.nivel;
        }
        if (this.grid.instance.getSelectedRowsData().length == 0) {
            return "Se tiene que seleccionar mínimo un tipo de evaluación para guardar"
        }
        return true;
    }

    Guardar() {
        this.grid.instance.saveEditData();
        let periodoevaluacionportipoevaluacion = [];
        let entidadperiodo = new PeriodoEvaluacion(this.entidad);
        let validarinfo = this.Validar()
        if (validarinfo == true) {
            if (this.grid.instance.getSelectedRowsData().length > 0) {
                for (let tipoevalua of this.grid.instance.getSelectedRowsData()) {
                    let info = {"fechainicioevaluacion": tipoevalua.fechainicioevaluacion, "preguntaloconoces": tipoevalua.preguntaloconoces, "tipoevaluacionid": tipoevalua.tipoevaluacionid, "periodoevaluacionportipoevaluacionid": tipoevalua.periodoevaluacionportipoevaluacionid}
                    periodoevaluacionportipoevaluacion.push(info)
                }
            }
            let data = {"periodoevaluacion": entidadperiodo, "listeliminar": this.listtipoevaluacioneliminar, "periodoportipocopia": [], "periodoportipo": periodoevaluacionportipoevaluacion}
            this.appService.Post("planeacion/periodoevaluacion", data).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                    this.cambio = true
                    this.limpiarcampos = 0;
                    //this.generaracuerdos(res.data.id);
                    this.Salir()
                }
            })
        }
        else {
            this.mensajeService.Alerta(AlertaEnum.Warning, validarinfo);
        }

    }

    generaracuerdos(periodoevaluacionid: number){
      this.appService.Get("acuerdo/asignacion/generaracuerdo/"+periodoevaluacionid, [HeaderEnum.NoShowLoading]).then(res=>{

      })
    }

    mensajeacuerdos(){
      let opciones = this.sistemaService.GetOpcionesAceptar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Vas a generar los acuerdos de este periodo de evaluación <br> esta acción puede tardar varios minutos.', opciones).then(res => {
          if (res == 1) {
            this.generaracuerdos(this.entidad.periodoevaluacionid);
          }
      })
    }

    formatDate(date: string) {
        let valor = date.split("/")
        let fecha = valor[2] + "-" + valor[1] + "-" + valor[0];
        return fecha;
    }

    ValidarFecha() {
        if(this.accion.accionid == 1){
            this.configuracionDatePicker = {disableSince: {}};
            this.configuracionDatePicker2 = {disableUntil: {}, disableSince: {}};
            this.configuracionDatePicker3 = {disableUntil: {}};
        }else{
        let fechas = new PeriodoEvaluacion(this.entidad)

        if (!fechas.fechainicioperiodo) {
            this.fechainicioperiodo = new Date("01/01/1000")
        } else {
            this.fechainicioperiodo = new Date(fechas.fechainicioperiodo + "T00:00:00")
            this.fechainicioperiodo = new Date(this.fechainicioperiodo.setDate(this.fechainicioperiodo.getDate() + 1))
        }

        if (!fechas.fechainicioacuerdos) {
            this.fechainicioacuerdo = new Date("01/01/2500")
        } else {
            this.fechainicioacuerdo = new Date(fechas.fechainicioacuerdos + "T00:00:00")
            this.fechainicioacuerdo = new Date(this.fechainicioacuerdo.setDate(this.fechainicioacuerdo.getDate() - 1))
        }

        if (!fechas.fechafinacuerdos) {
            this.fechafinacuerdos = new Date("01/01/2500")
            this.fechainicioacuerdoparafin = new Date("01/01/1000")
        } else {
            this.fechafinacuerdos = new Date(fechas.fechafinacuerdos + "T00:00:00")
            this.fechafinacuerdos = new Date(this.fechafinacuerdos.setDate(this.fechafinacuerdos.getDate() + 1))

            this.fechainicioacuerdoparafin = new Date(fechas.fechainicioacuerdos + "T00:00:00")
            this.fechainicioacuerdoparafin = new Date(this.fechainicioacuerdoparafin.setDate(this.fechainicioacuerdoparafin.getDate() - 1))
        }

        this.minDate = new Date(this.fechainicioperiodo);
        this.maxDate = new Date(this.fechainicioacuerdo);


        this.configuracionDatePicker = {disableSince: {year: this.fechainicioacuerdo.getFullYear(), month: this.fechainicioacuerdo.getMonth() + 1, day: this.fechainicioacuerdo.getDate() + 1}};
        this.configuracionDatePicker2 = {disableUntil: {year: this.fechainicioperiodo.getFullYear(), month: this.fechainicioperiodo.getMonth() + 1, day: this.fechainicioperiodo.getDate() - 1}, disableSince: {year: this.fechafinacuerdos.getFullYear(), month: this.fechafinacuerdos.getMonth() + 1, day: this.fechafinacuerdos.getDate() - 1}};
        this.configuracionDatePicker3 = {disableUntil: {year: this.fechainicioacuerdoparafin.getFullYear(), month: this.fechainicioacuerdoparafin.getMonth() + 1, day: this.fechainicioacuerdoparafin.getDate() + 1}};
        }
    }

    ValidarFechaInicioPeriodo() {
        let fechas = new PeriodoEvaluacion(this.entidad)
        if (!fechas.fechainicioperiodo) {
            this.fechainicioperiodo = new Date("01/01/1000")
            this.LimpiarFechasTabla();
        } else {
            this.fechainicioperiodo = new Date(fechas.fechainicioperiodo + "T00:00:00")
            this.fechainicioperiodo = new Date(this.fechainicioperiodo.setDate(this.fechainicioperiodo.getDate() + 1))
        }

        this.datepiker2.addConfiguracion.disableUntil.day = this.fechainicioperiodo.getDate() - 1
        this.datepiker2.addConfiguracion.disableUntil.month = this.fechainicioperiodo.getMonth() + 1
        this.datepiker2.addConfiguracion.disableUntil.year = this.fechainicioperiodo.getFullYear()

        this.minDate = new Date(this.fechainicioperiodo);
        this.grid.instance.refresh();


    }

    ValidarFechaInicioAcuerdo() {
        let fechas = new PeriodoEvaluacion(this.entidad)
        if (!fechas.fechainicioacuerdos) {
            this.fechainicioacuerdo = new Date("01/01/2500")
            this.fechainicioacuerdoparafin = new Date("01/01/1000")
            this.LimpiarFechasTabla();
        } else {
            this.fechainicioacuerdo = new Date(fechas.fechainicioacuerdos + "T00:00:00")
            this.fechainicioacuerdo = new Date(this.fechainicioacuerdo.setDate(this.fechainicioacuerdo.getDate() - 1))

            this.fechainicioacuerdoparafin = new Date(fechas.fechainicioacuerdos + "T00:00:00")
            this.fechainicioacuerdoparafin = new Date(this.fechainicioacuerdoparafin.setDate(this.fechainicioacuerdoparafin.getDate() - 1))
        }
        this.datepiker.addConfiguracion.disableSince.day = this.fechainicioacuerdo.getDate() + 1
        this.datepiker.addConfiguracion.disableSince.month = this.fechainicioacuerdo.getMonth() + 1
        this.datepiker.addConfiguracion.disableSince.year = this.fechainicioacuerdo.getFullYear()

        this.datepiker3.addConfiguracion.disableUntil.day = this.fechainicioacuerdoparafin.getDate() + 1
        this.datepiker3.addConfiguracion.disableUntil.month = this.fechainicioacuerdoparafin.getMonth() + 1
        this.datepiker3.addConfiguracion.disableUntil.year = this.fechainicioacuerdoparafin.getFullYear()

        this.maxDate = new Date(this.fechainicioacuerdo);
        this.grid.instance.refresh();
    }

    ValidarFechaFinAcuerdo() {
        let fechas = new PeriodoEvaluacion(this.entidad)
        if (!fechas.fechafinacuerdos) {
            this.fechafinacuerdos = new Date("01/01/2500")
        } else {
            this.fechafinacuerdos = new Date(fechas.fechafinacuerdos + "T00:00:00")
            this.fechafinacuerdos = new Date(this.fechafinacuerdos.setDate(this.fechafinacuerdos.getDate() + 1))
        }

        this.datepiker2.addConfiguracion.disableSince.day = this.fechafinacuerdos.getDate() - 1
        this.datepiker2.addConfiguracion.disableSince.month = this.fechafinacuerdos.getMonth() + 1
        this.datepiker2.addConfiguracion.disableSince.year = this.fechafinacuerdos.getFullYear()
    }

    onSelectionChanged(e: any) {
        this.grid.instance.cancelEditData();
        this.grid.instance.saveEditData();

        (e.currentDeselectedRowKeys as any[]).forEach(x => {
            x.preguntaloconoces = false;
            x.fechainicioevaluacion = null;
            if (x.periodoevaluacionportipoevaluacionid) {
                this.listtipoevaluacioneliminar.push(x);
            }
        });

        (e.currentSelectedRowKeys as any[]).forEach(x => {
            if (x.periodoevaluacionportipoevaluacionid) {
                let periodoportipo = this.listtipoevaluacioneliminar.find((id: any) => id.periodoevaluacionportipoevaluacionid == x.periodoevaluacionportipoevaluacionid);
                if (periodoportipo) {
                    let index = this.listtipoevaluacioneliminar.findIndex((x: any) => x.tipoevaluacionid = periodoportipo.tipoevaluacionid);
                    this.listtipoevaluacioneliminar.splice(index, 1);
                }
            }
        });
    }


    LimpiarFechasTabla() {
        this.SelDataPeriodoporTipo.forEach((x: any, i: number) => {
            this.grid.instance.cellValue(i, 'fechainicioevaluacion', null)
        })
        this.grid.instance.saveEditData();
        this.grid.instance.cancelEditData();
    }

    Eliminar(e: PeriodoEvaluacion) {
        let opciones = this.sistemaService.GetOpcionesSalir();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Al salir de esta pantalla se perderá toda la información registrada. <br> Esta acción no podrá ser revertida.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("planeacion/periodoevaluacion/" + e.periodoevaluacionid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.cambio = true;
                        this.output.next(this.cambio);
                    }
                })
            }
        })
    }

}
